import { createContext, ReactElement } from "react";
import { BaseColumnProps } from "./BaseColumnProps";

/** The table layout context value. */
export interface TableLayoutContextValue {

  /** The left-locked table columns. */
  readonly leftColumns: ReadonlyArray<ReactElement<BaseColumnProps>>;

  /** The middle table columns. */
  readonly middleColumns: ReadonlyArray<ReactElement<BaseColumnProps>>;

  /** The right-locked table columns. */
  readonly rightColumns: ReadonlyArray<ReactElement<BaseColumnProps>>;

  /** The left column offsets. */
  readonly leftOffsets: ReadonlyArray<number>;

  /** The right column offsets. */
  readonly rightOffsets: ReadonlyArray<number>;

  /** The width of the table viewport. */
  readonly viewportWidth: number;
}

/** The table layout context. */
export const TableLayoutContext = createContext<TableLayoutContextValue>({
  leftColumns: [],
  middleColumns: [],
  rightColumns: [],
  leftOffsets: [],
  rightOffsets: [],
  viewportWidth: 0,
});
